"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timer = void 0;
/**
 * A timer function.
 */
function timer() {
    const timeStart = new Date().getTime();
    return {
        /**
         * Gets seconds elapsed since start.
         */
        get seconds() {
            return Math.ceil(new Date().getTime() - timeStart / 1000);
        },
        /**
         * Gets milli seconds elapsed since start.
         */
        get milliSeconds() {
            return new Date().getTime() - timeStart;
        },
    };
}
exports.timer = timer;
//# sourceMappingURL=timer.js.map